import React from "react";
import { Backdrop } from "@mui/material";
import "./Loading.css";

const Loading = ({ open }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      {/* <div className="loader"></div> */}
    </Backdrop>
  );
};

export default Loading;
